var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditcards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 567,
    viewBox: "0 0 433 567",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1754_965)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 432.018,
    height: 566.984,
    rx: 32,
    transform: "matrix(1 0 -0.000125187 1 0.0712891 0.015625)",
    fill: "url(#paint0_radial_1754_965)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.999875,
    y: 1,
    width: 430.018,
    height: 564.984,
    rx: 31,
    transform: "matrix(1 0 -0.000125187 1 0.0714142 0.015625)",
    stroke: "url(#paint1_linear_1754_965)",
    strokeOpacity: 0.3,
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1754_965",
    x: -12,
    y: -11.9844,
    width: 456.09,
    height: 590.984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1754_965"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1754_965",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1754_965",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.92164 -31.4992) rotate(54.7417) scale(732.935 585.896)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A5311",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232336",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1754_965",
    x1: 0,
    y1: 0,
    x2: 393.474,
    y2: 336.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE",
    stopOpacity: 0.23
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcards);
export default __webpack_public_path__ + "static/media/Credit cards.95853121d71dcec2ee4d1feb092a675e.svg";
export { ForwardRef as ReactComponent };